import z from "zod";

const translationPath = "page.4uDlist.list.errors.";

const listCategoriesSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const listClassificationsSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.number().nullish(),
});

const integrationTypeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "integration_type" }
);

export const convertToNewListSchema = z.object({
  enable: z.boolean(),
  name: z
    .string()
    .trim()
    .min(1, translationPath + "name")
    .max(255, translationPath + "name_max_length"),
  description: z.string().nullish(),
  integrationType: integrationTypeSchema,
  listCategories: z
    .array(listCategoriesSchema)
    .min(1, translationPath + "list_categories"),
  listClassifications: z
    .array(listClassificationsSchema)
    .min(1, translationPath + "list_classifications"),
});

export type TConvertToNewListForm = z.infer<typeof convertToNewListSchema>;
